import { Route } from 'vue-router';

export interface ITopNavigationOptions {
    title?: string | ((route: Route) => string);
    isLight?: boolean;
    showBack?: boolean;
    showHelp?: boolean;
    showBalance?: boolean;
}

export function lightTopNavigation(
    title: ITopNavigationOptions['title'],
    showHelp?: boolean,
) {
    return topNavigation({
        title,
        isLight: true,
        showBack: true,
        ...(showHelp !== undefined && { showHelp }),
    });
}

export function topNavigation(options: ITopNavigationOptions) {
    return { topNavigation: options };
}
